/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IPageWrapperData } from './page-wrapper.data';
import { IPageWrapperProps } from './page-wrapper.props.autogenerated';

export interface IPageWrapperViewProps extends IPageWrapperProps<IPageWrapperData> {}

/**
 *
 * PageWrapper component
 * @extends {React.PureComponent<IPageWrapperProps<IPageWrapperData>>}
 */
class PageWrapper extends React.PureComponent<IPageWrapperProps<IPageWrapperData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default PageWrapper;
